import Swiper from "swiper";
import {
	Pagination,
	EffectCreative,
	Keyboard,
	Mousewheel,
	Navigation,
	Thumbs,
	EffectFade,
	Autoplay,
	EffectCoverflow,
	Grid,
	FreeMode,
} from "swiper/modules";

/**
 * @param swiperInit
 */
export default function swiperInit() {
	// Home banner slider
	new Swiper(".home-1 .swiper", {
		modules: [Pagination, Autoplay, Navigation],
		slidesPerView: 1,
		speed: 1000,
		spaceBetween: 0,
		navigation: {
			nextEl: ".home-1 .btn-next",
			prevEl: ".home-1 .btn-prev",
		},
		autoplay: {
			delay: 5000,
			pauseOnMouseEnter: true,
		},
		loop: true,
	});

	// 3 columns slider
	const swiper3Col = new Swiper(".col-3-items .swiper", {
		modules: [Pagination, Autoplay, Navigation],
		slidesPerView: 1,
		spaceBetween: 40,
		autoplay: {
			delay: 5000,
			speed: 500,
			pauseOnMouseEnter: true,
		},
		loop: true,
		pagination: {
			el: ".col-3-items .swiper-pagination",
			clickable: true,
		},
		navigation: {
			nextEl: ".col-3-items .btn-next",
			prevEl: ".col-3-items .btn-prev",
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
			},
			1290: {
				slidesPerView: 3,
			},
		},
	});

	// 4 columns slider
	const swiper4Col = new Swiper(".col-4-items .swiper", {
		modules: [Pagination, Autoplay, Navigation],
		slidesPerView: 2,
		spaceBetween: 15,
		autoplay: {
			delay: 3000,
			speed: 500,
			pauseOnMouseEnter: true,
		},
		loop: true,
		pagination: {
			el: ".col-4-items .swiper-pagination-fraction",
			clickable: true,
			type: "fraction",
		},
		navigation: {
			nextEl: ".col-4-items .btn-next",
			prevEl: ".col-4-items .btn-prev",
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
			},
			1200: {
				slidesPerView: 4,
			},
		},
	});

	// 6 columns slider
	const swiper6Col = new Swiper(".col-6-items .swiper", {
		modules: [Pagination, Autoplay, Navigation],
		slidesPerView: 3,
		spaceBetween: 32,
		loopedSlides: 8,
		speed: 5000,
		freeMode: true,
		watchSlidesVisibility: true,
		autoplay: {
			delay: 0,
			pauseOnMouseEnter: false,
			disableOnInteraction: false,
		},
		loop: true,
		pagination: {
			el: ".col-6-items .swiper-pagination",
			clickable: true,
			type: "progressbar",
		},
		navigation: {
			nextEl: ".col-6-items .btn-next",
			prevEl: ".col-6-items .btn-prev",
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
				centeredSlides: false,
			},
			1200: {
				slidesPerView: 5,
				centeredSlides: true,
			},
		},
	});

	// Single slide slider
	const swiper1Col = new Swiper(".col-1-items .swiper", {
		modules: [Pagination, Autoplay, Navigation, EffectFade],
		slidesPerView: 1,
		spaceBetween: 0,
		autoplay: {
			delay: 4000,
			speed: 500,
			pauseOnMouseEnter: true,
		},
		loop: true,
		effect: "slide",
		pagination: {
			el: ".col-1-items .swiper-pagination",
			clickable: true,
			type: "bullets",
		},
		navigation: {
			nextEl: ".col-1-items .btn-next",
			prevEl: ".col-1-items .btn-prev",
		},
	});

	// Q&A slider
	const swiperQA = new Swiper(".col-1-items-qa .swiper", {
		modules: [Pagination, Autoplay, Navigation, EffectFade],
		slidesPerView: 1,
		spaceBetween: 0,
		autoplay: {
			delay: 5000,
			speed: 500,
			pauseOnMouseEnter: true,
		},
		speed: 500,
		loop: true,
		pagination: {
			el: ".col-1-items-qa .swiper-pagination-fraction",
			clickable: true,
			type: "fraction",
			formatFractionCurrent: function (number) {
				return ("0" + number).slice(-2);
			},
			formatFractionTotal: function (number) {
				return ("0" + number).slice(-2);
			},
		},
		navigation: {
			nextEl: ".col-1-items-qa .btn-next",
			prevEl: ".col-1-items-qa .btn-prev",
		},
	});

	// Set default active state for first icon item
	$(".icon-item[data-index='0']").addClass("active");

	// Handle icon item clicks
	$(".icon-item").on("click", function () {
		$(".icon-item").removeClass("active");
		$(this).addClass("active");
		swiperQA.slideTo($(this).data("index"));
	});

	// Synchronize active class with slider
	swiperQA.on("slideChange", function () {
		$(".icon-item").removeClass("active");
		$(".icon-item[data-index='" + swiperQA.realIndex + "']").addClass(
			"active"
		);
	});
	// single team slider
	const swiperTeam = new Swiper(".col-1-items-team .swiper", {
		modules: [Pagination, Autoplay, Navigation, EffectFade],
		slidesPerView: 1,
		spaceBetween: 0,
		autoplay: {
			delay: 15000,
			speed: 500,
			pauseOnMouseEnter: true,
		},
		speed: 500,
		loop: true,
		pagination: {
			el: ".col-1-items-team .swiper-pagination-fraction",
			clickable: true,
			type: "fraction",
			formatFractionCurrent: function (number) {
				return ("0" + number).slice(-2);
			},
			formatFractionTotal: function (number) {
				return ("0" + number).slice(-2);
			},
		},
		navigation: {
			nextEl: ".col-1-items-team .btn-next",
			prevEl: ".col-1-items-team .btn-prev",
		},
	});

	// Set default active state for first icon item
	$(".icon-item-team[data-index='0']").addClass("active");

	// Handle icon item clicks
	$(".icon-item-team").on("click", function () {
		$(".icon-item-team").removeClass("active");
		$(this).addClass("active");
		swiperTeam.slideTo($(this).data("index"));
	});

	// Synchronize active class with slider
	swiperTeam.on("slideChange", function () {
		$(".icon-item-team").removeClass("active");
		$(".icon-item-team[data-index='" + swiperTeam.realIndex + "']").addClass(
			"active"
		);
	});
}
